import { FilterOption } from 'src/components/Tickets/models/Tickets.interface';

export const createFilterOptionsFactory = (
  entries: [string | number, { label: string }][]
): FilterOption[] => {
  return entries.map(([id, value]) => {
    return {
      label: value.label,
      id: id,
      checked: false,
    };
  }) as FilterOption[];
};
